import { notificationTemplateTranslation } from '../constants';

const contactSupport = `{{#with prefs}}{{#if supportPhone}}al {{supportPhone}} {{/if}}{{#if supportPhone}}{{#if supportEmail}}o {{/if}}{{/if}}{{#if supportEmail}}a {{supportEmail}}{{/if}}{{/with}}`;

const defaultCourierAssignedTemplate = {
  smsTemplate: `La orden #{{order.id}} esta lista para entregar. eLocker Maletek`,
  emailSubject: `Orden lista para entrega`,
  emailTemplate: `{{courier.name}},

La orden **#{{order.id}}** está lista para entregar en el eLocker **{{locker.name}}**.

**Orden:** #{{order.id}}
**Código de entrega:** {{order.dropCode}}

eLocker {{locker.name}}** en **{{location.name}}

**Cómo llegar:**

{{location.address}}

{{location.description}}

Una vez que te autentiques, escanea el código que aparece en el paquete
y se abrirá automáticamente la puerta de entrega.

**eLockers de Maletek**
`,
};

const defaultCourierReversalTemplate = {
  smsTemplate: `La orden #{{order.id}} ha sido revocada. eLocker Maletek`,
  emailSubject: `Orden revocada`,
  emailTemplate: `{{courier.name}},

Se ha revocado una orden y ya puede ser retirada del eLocker.

Orden: **#{{order.id}}**
{{#if order.courierPickupCode}}Código de retiro: **{{order.courierPickupCode}}**{{/if}}

**{{location.name}} - eLocker {{locker.name}}**

**Cómo llegar:**
{{location.address}}
{{location.description}}

{{#if order.courierPickupCode}}
Una vez que te identifiques, ingresa el código de retiro **{{order.courierPickupCode}}** y se abrirá la puerta correspondiente.
{{else}}
Una vez que te identifiques, verás la orden #{{order.id}} en la lista, y podrás retirarlo eligiendo la opción "Retirar".
{{/if}}
**eLockers de Maletek**`,
};

const defaultCourierCompletedTemplate = {
  smsTemplate: `La orden #{{order.id}} ha sido completada con exito. eLocker Maletek`,
  emailSubject: `Orden completada`,
  emailTemplate: `{{courier.name}},

  La orden #{{order.id}} ha sido retirada del eLocker {{locker.name}}(#{{locker.id}}), por lo que ha sido completada con éxito.

  **eLockers de Maletek**`,
};

const defaultCourierCancelledTemplate = {
  smsTemplate: `La orden #{{order.id}} ha sido cancelada. eLocker Maletek`,
  emailSubject: `Orden cancelada`,
  emailTemplate: `{{courier.name}},

  La orden #{{order.id}} ha sido cancelada, por lo que el paquete ya no podrá ser entregado en el eLocker.

  **eLockers de Maletek**`,
};

const defaultCourierReadyTemplate = {
  smsTemplate: `La orden #{{order.id}} fue entregada en puerta y esta lista para retiro. eLocker Maletek`,
  emailSubject: `Orden lista para retiro.`,
  emailTemplate: `{{courier.name}},

  La orden #{{order.id}} fue entregada en puerta, por lo que se encuentra lista para retiro por el destinatario.

  **eLockers de Maletek**`,
};

const defaultPickupReadyTemplate = {
  smsTemplate: `Tu paquete {{#if client.name}}de {{client.name}} {{/if}}esta disponible para retiro. Se enviaron detalles a tu email {{order.pickupEmail}}. eLocker Maletek.`,
  emailSubject: `Tu paquete está disponible para retiro`,
  emailTemplate: `{{order.pickupName}},

Tu paquete {{#if client.name}}de {{client.name}} {{/if}}está disponible en el eLocker "{{locker.name}}", ubicado en {{location.name}}.

Para retirar tu paquete, escanea el código que aparece a continuación o digitalo en la pantalla del eLocker.
{{#if order.autoReversalAt}}
Tienes hasta {{formatDate order.autoReversalAt}} para retirar tu paquete.
{{/if}}
![{{order.pickupCode}}]({{barcodeGeneratorEndpoint}}/{{order.pickupCode}}.png)

Número de Orden: {{order.id}}.

Código de retiro: **{{order.pickupCode}}**

Cómo llegar a **{{location.name}}:**
[{{location.address}}]({{{mapUrl location.address}}})
{{location.description}}

Gracias por preferir eLockers de Maletek. Si tienes dudas o consultas con tu orden, no dudes en contactarnos ${contactSupport}.`,
};

const defaultPickupReminderTemplate = {
  smsTemplate: `Te recordamos que tu paquete {{#if client.name}}de {{client.name}} {{/if}}esta disponible para retiro. {{#if order.autoReversalAt}}Tienes {{countDays now order.autoReversalAt}} días para retirarlo.{{/if}}eLocker Maletek.`,
  emailSubject: `Te recordamos que tu paquete {{#if client.name}}de {{client.name}} {{/if}}esta disponible para retiro`,
  emailTemplate: `{{order.pickupName}},

Te recordamos que tu paquete {{#if client.name}}de {{client.name}} {{/if}}está disponible en el eLocker "{{locker.name}}", ubicado en {{location.name}}.

{{#if order.autoReversalAt}}
Tienes hasta {{formatDate order.autoReversalAt}} para retirar tu paquete.
{{/if}}

Para retirar tu paquete, escanea el código que aparece a continuación o digitalo en la pantalla del eLocker.

![{{order.pickupCode}}]({{barcodeGeneratorEndpoint}}/{{order.pickupCode}}.png)

Número de Orden: {{order.id}}

Código de retiro: **{{order.pickupCode}}**

Cómo llegar a **{{location.name}}:**
[{{location.address}}]({{{mapUrl location.address}}})
{{location.description}}

Gracias por preferir eLockers de Maletek. Si tienes dudas o consultas con tu orden, no dudes en contactarnos ${contactSupport}.`,
};

const defaultPickupCompletedTemplate = {
  smsTemplate: `Tu paquete de {{client.name}} fue retirado con exito del eLocker {{locker.name}}. Gracias por utilizar eLockers Maletek.`,
  emailSubject: `Tu paquete fue retirado`,
  emailTemplate: `Tu paquete en eLocker {{location.name}}, orden #{{order.id}} ha sido retirado. Gracias por utilizar eLockers de Maletek.

Si tienes alguna consulta, puedes contactarnos ${contactSupport}.`,
};

const defaultPickupReversalTemplate = {
  smsTemplate: `Tu orden de {{client.name}} ha expirado. Ponte en contacto con {{client.name}} para volver a pedirlo.`,
  emailSubject: `Tu orden ha expirado`,
  emailTemplate: `Tu paquete en eLocker {{location.name}}, orden #{{order.id}} ha expirado y está siendo devuelta a la bodega de {{client.name}} luego de haber estado {{countHours order.readyAt now}} horas esperando retiro.
Ponte en contacto con {{client.name}} para volver a pedirlo.

Si tienes alguna consulta, puedes contactarnos ${contactSupport}.`,
};

const default48hWarningTemplate = {
  smsTemplate: `Tu paquete de {{client.name}} lleva dos dias horas esperando retiro. Tienes hasta {{order.after3d}} para retirarlo, o sera devuelto a {{client.name}}{{^client.name}}su origen{{/client.name}}`,
  emailSubject: `Tu paquete lleva dos días esperando retiro`,
  emailTemplate: `Tu paquete lleva dos días en el eLocker {{locker.name}} esperando a que lo retires.
Tienes hasta {{order.after3d}} para retirar tu paquete, o sera devuelto a {{client.name}}{{^client.name}}su origen{{/client.name}}.`,
};

const default72hWarningTemplate = {
  smsTemplate: `Hemos extendido plazo para retirar tu paquete. Tienes hasta {{order.after4d}} para retirarlo`,
  emailSubject: `Hemos extendido plazo para que retires tu paquete`,
  emailTemplate: `Tu paquete lleva tres días en el eLocker {{locker.name}} esperando a que lo retires.
Tienes hasta {{order.after4d}} para retirar tu paquete, o sera devuelto a {{client.name}}{{^client.name}}su origen{{/client.name}}.`,
};

const defaultReturnReservedTemplate = {
  smsTemplate: `La orden #{{order.id}} esta lista para devolucion. eLocker Maletek`,
  emailSubject: `Orden lista para devolución`,
  emailTemplate: `Estimado {{pickupName}},

Ya puedes entregar tu paquete de devolución **#{{order.id}}** en el eLocker **{{locker.name}}**, ubicado en **{{location.name}}**.

Recuerda incluir una copia de la factura y todas las partes y embalajes del producto que estás devolviendo.

Una vez que llegues al locker, escanea o escribe el código a continuación y se abrirá automáticamente la puerta donde debes depositar el paquete.

![{{order.dropCode}}]({{barcodeGeneratorEndpoint}}/{{order.dropCode}}.png)


**Código de entrega:** {{order.dropCode}}
**Orden:** #{{order.id}}

**eLocker {{locker.name}}**
**{{location.name}}**

{{location.address}}

**Cómo llegar:**

{{location.address}}

{{location.description}}


**eLockers de Maletek**
`,
};

const defaultReturnReadyTemplate = {
  smsTemplate: `La devolución #{{order.id}} fue entregada en puerta y esta lista para ser retirada. eLocker Maletek`,
  emailSubject: `Devolución lista para retiro.`,
  emailTemplate: `Estimado {{courier.name}},

La devolución **#{{order.id}}** fue entregada en el eLocker **{{locker.name}}**, ubicado en **{{location.name}}, y está lista para recoger.

Una vez registrado, escanea o escribe el código a continuación para retirar el paquete.

![{{order.pickupCode}}]({{barcodeGeneratorEndpoint}}/{{order.pickupCode}}.png)

**Orden:** #{{order.id}}
**Código de entrega:** {{order.pickupCode}}

**eLocker {{locker.name}}**
**{{location.name}}**


**Cómo llegar:**

{{location.address}}

{{location.description}}

**eLockers de Maletek**
`,
};

const defaultReturnCancelledTemplate = {
  smsTemplate: `La orden #{{order.id}} ha sido cancelada. eLocker Maletek`,
  emailSubject: `Orden cancelada`,
  emailTemplate: `Estimado {{pickupName}},

  La orden #{{order.id}} ha sido cancelada, por lo que el paquete ya no podrá ser entregado en el eLocker.

  **eLockers de Maletek**`,
};

const defaultReturnReversalTemplate = {
  smsTemplate: `La orden #{{order.id}} ha sido revocada. eLocker Maletek`,
  emailSubject: `Orden expirada`,
  emailTemplate: `Estimado {{pickupName}},

  La orden #{{order.id}} ha expirado ya que superó el plazo máximo de entrega, por lo que el paquete ya no podrá ser entregado en el eLocker.

  **eLockers de Maletek**`,
};

const defaultHeaderTemplate = {
  emailTemplate: `
<div style="max-width: 600px; font-family: helvetica, arial, sans-serif; font-size: 14px; line-height: 1.2;">
`,
};

const defaultFooterTemplate = {
  emailTemplate: `
</div>
`,
};

const defaultUserRegisterTemplate = {
  emailSubject: `Custodia {{locker.name}}`,
  emailTemplate: `Hola {{name}},
Bienvenido a {{locker.name}} de {{client.name}} Tu solicitud de custodia fué exitosa.

Aqui va tu código para utilizar el casillero:

![{{token}}]({{barcodeGeneratorEndpoint}}/{{token}}.png&bcid=qrcode)

Este código es único y te permitirá abrir el casillero en cualquier momento.
Es importante que lo guardes en un lugar seguro, ya que es la única forma de acceder a tus artículos.

Es valido por 24 horas, por lo que debes terminar de usarlo antes de que expire.

Como usar:

1) Presiona guardar en la pantalla del casillero
2) Elige un tamaño de puerta
3) escanea el código que te llegó aquí. 
4) Guarda tus artículos dentro del casillero y cierra la puerta.
5) Puedes abrir la misma puerta para añadir o retirar artículos en cualquier momento.
6) Para terminar de usar retira todos los artículos y cierra la puerta, luego presiona "Terminar" en la pantalla del casillero.

Si tienes alguna duda, puedes contactarnos a través de nuestro correo electrónico {{client.supportEmail}} o al teléfono {{client.supportPhone}}.  

Gracias por elegir {{locker.locationName}} de {{client.name}}.

Saludos
`,
};

const defaultPickupReservedTemplate = {
  smsTemplate: `Tu orden #{{order.id}} esta lista para entrega en el eLocker {{locker.name}}. eLocker Maletek.`,
  emailSubject: `Tu orden está lista para entrega`,
  emailTemplate: `{{order.pickupName}},

Tu orden **#{{order.id}}** está lista para entrega en el eLocker **{{locker.name}}**, ubicado en **{{location.name}}**.

Una vez que llegues al locker, escanea o escribe el código a continuación y se abrirá automáticamente la puerta donde debes depositar el paquete.

![{{order.dropCode}}]({{barcodeGeneratorEndpoint}}/{{order.dropCode}}.png)

**Código de entrega:** {{order.dropCode}}
**Orden:** #{{order.id}}

**eLocker {{locker.name}}**
**{{location.name}}**

{{location.address}}

**Cómo llegar:**

{{location.address}}

{{location.description}}  
**eLockers de Maletek**
`,
};

const defaultCancelPickupReservedTemplate = {
  smsTemplate: `Tu orden #{{order.id}} ha sido cancelada. eLocker Maletek.`,
  emailSubject: `Tu orden ha sido cancelada`,
  emailTemplate: `{{order.pickupName}},

La orden **#{{order.id}}** ha sido cancelada, por lo que el paquete ya no podrá ser entregado en el eLocker.

**eLockers de Maletek**
`,
};

const labelFor = (type) => {
  const key = `${type}Template`;
  const translated = notificationTemplateTranslation.get(key);
  return translated && translated !== key ? translated : type;
};

const entry = (type, group, defaults, channels) => ({
  type,
  group,
  label: labelFor(type),
  defaults,
  channels,
});

export const notificationTemplateCatalog = [
  entry('header', 'Formato', defaultHeaderTemplate, null),
  entry('footer', 'Formato', defaultFooterTemplate, null),
  entry('pickupReserved', 'Destinatario', defaultPickupReservedTemplate, {
    email: 'sendPickupReservedEmail',
  }),
  entry('cancelPickupReserved', 'Destinatario', defaultCancelPickupReservedTemplate, {
    email: 'sendCancelPickupReservedEmail',
  }),
  entry('pickupReady', 'Destinatario', defaultPickupReadyTemplate, {
    sms: 'sendPickupReadySms',
    email: 'sendPickupReadyEmail',
    whatsApp: 'sendPickupReadyWhatsApp',
  }),
  entry('pickupReminder', 'Destinatario', defaultPickupReminderTemplate, {
    sms: 'sendPickupReminderSms',
    email: 'sendPickupReminderEmail',
    whatsApp: 'sendPickupReminderWhatsApp',
  }),
  entry('pickupCompleted', 'Destinatario', defaultPickupCompletedTemplate, {
    sms: 'sendPickupCompletedSms',
    email: 'sendPickupCompletedEmail',
    whatsApp: 'sendPickupCompletedWhatsApp',
  }),
  entry('pickupReversal', 'Destinatario', defaultPickupReversalTemplate, {
    sms: 'sendPickupReversalSms',
    email: 'sendPickupReversalEmail',
  }),
  entry('warning48h', 'Destinatario', default48hWarningTemplate, null),
  entry('warning72h', 'Destinatario', default72hWarningTemplate, null),
  entry('courierAssigned', 'Courier', defaultCourierAssignedTemplate, {
    sms: 'sendCourierAssignedSms',
    email: 'sendCourierAssignedEmail',
  }),
  entry('courierCancelled', 'Courier', defaultCourierCancelledTemplate, {
    sms: 'sendCourierCancelledSms',
    email: 'sendCourierCancelledEmail',
  }),
  entry('courierReady', 'Courier', defaultCourierReadyTemplate, {
    sms: 'sendCourierReadySms',
    email: 'sendCourierReadyEmail',
  }),
  entry('courierReversal', 'Courier', defaultCourierReversalTemplate, {
    sms: 'sendCourierReversalSms',
    email: 'sendCourierReversalEmail',
  }),
  entry('courierCompleted', 'Courier', defaultCourierCompletedTemplate, {
    sms: 'sendCourierCompletedSms',
    email: 'sendCourierCompletedEmail',
  }),
  entry('returnReserved', 'Devolución', defaultReturnReservedTemplate, {
    sms: 'sendReturnReservedSms',
    email: 'sendReturnReservedEmail',
  }),
  entry('returnReady', 'Devolución', defaultReturnReadyTemplate, {
    sms: 'sendReturnReadySms',
    email: 'sendReturnReadyEmail',
  }),
  entry('returnCancelled', 'Devolución', defaultReturnCancelledTemplate, {
    sms: 'sendReturnCancelledSms',
    email: 'sendReturnCancelledEmail',
  }),
  entry('returnReversal', 'Devolución', defaultReturnReversalTemplate, {
    sms: 'sendReturnReversalSms',
    email: 'sendReturnReversalEmail',
  }),
  entry('userRegister', 'Registro', defaultUserRegisterTemplate, null),
];

export const channelLabel = {
  sms: 'SMS',
  email: 'Email',
  whatsApp: 'WhatsApp',
};

export const hasTemplateContent = (value) => {
  const raw = String(value || '').trim();
  if (!raw || raw === '<p></p>' || raw === '<p><br></p>' || raw === '<br>') return false;
  const text = raw
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .trim();
  if (text) return true;
  return /<\/?[a-z][^>]*>/i.test(raw);
};

const closeKind = (token) => {
  if (token.kind === 'if') return 'if';
  if (token.kind === 'with') return 'with';
  return token.name;
};

export const templateSyntaxErrors = (source, label) => {
  const text = String(source || '');
  if (!text.trim()) return [];
  const errors = [];
  const opens = text.match(/\{\{/g) || [];
  const closes = text.match(/\}\}/g) || [];
  if (opens.length !== closes.length) {
    errors.push(`${label}: hay marcas {{ }} sin cerrar o sin abrir.`);
  }
  const stack = [];
  const tokenRe = /\{\{\s*([^{}]+?)\s*\}\}/g;
  let match = tokenRe.exec(text);
  while (match) {
    const raw = match[1].trim();
    if (!raw) {
      errors.push(`${label}: hay una marca {{ }} vacía.`);
    } else if (raw.startsWith('#if')) {
      stack.push({ kind: 'if' });
    } else if (raw.startsWith('#with')) {
      stack.push({ kind: 'with' });
    } else if (raw.startsWith('^')) {
      const name = raw.slice(1).trim();
      if (!name) errors.push(`${label}: hay un bloque {{^}} sin nombre.`);
      else stack.push({ kind: 'inverse', name });
    } else if (raw === 'else') {
      const top = stack[stack.length - 1];
      if (!top || top.kind !== 'if') errors.push(`${label}: {{else}} está fuera de un {{#if}}.`);
    } else if (raw.startsWith('/')) {
      const name = raw.slice(1).trim();
      const top = stack.pop();
      if (!top) errors.push(`${label}: {{/${name}}} no tiene apertura.`);
      else if (closeKind(top) !== name) {
        errors.push(`${label}: {{/${name}}} cierra un {{${top.kind === 'inverse' ? `^${top.name}` : `#${top.kind}`}}}.`);
      }
    } else if (raw.startsWith('#') || raw.startsWith('/')) {
      errors.push(`${label}: bloque no reconocido {{${raw}}}.`);
    }
    match = tokenRe.exec(text);
  }
  if (stack.length) {
    errors.push(`${label}: faltan cierres de bloque.`);
  }
  return errors;
};

const fieldRequired = (label, value, required, errors) => {
  if (required && !hasTemplateContent(value)) errors.push(`${label} no puede quedar vacío.`);
  templateSyntaxErrors(value, label).forEach((error) => errors.push(error));
};

export const validateNotificationTemplate = ({
  emailSubject,
  emailTemplate,
  smsTemplate,
  defaults,
  channels,
  preferences,
}) => {
  const errors = [];
  const prefs = preferences || {};
  fieldRequired('Asunto', emailSubject, !!(defaults && hasTemplateContent(defaults.emailSubject)), errors);
  fieldRequired('Email', emailTemplate, !!(defaults && hasTemplateContent(defaults.emailTemplate)), errors);
  fieldRequired('SMS', smsTemplate, !!(defaults && hasTemplateContent(defaults.smsTemplate)), errors);
  if (channels && channels.email && prefs[channels.email] && !hasTemplateContent(emailTemplate)) {
    if (!errors.some((error) => error.indexOf('Email') === 0)) {
      errors.push('Email no puede quedar vacío porque el envío está activado.');
    }
  }
  if (channels && channels.sms && prefs[channels.sms] && !hasTemplateContent(smsTemplate)) {
    if (!errors.some((error) => error.indexOf('SMS') === 0)) {
      errors.push('SMS no puede quedar vacío porque el envío está activado.');
    }
  }
  return errors;
};
